import styled from 'styled-components'

import {media} from '../../theme/index'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const SearchWrapper = styled.div`
  .sui-search-box {
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    height: 3.75rem;
    justify-content: space-between;
    width: 100%;

    @media ${media.small} {
      height: 3.5rem;
    }
  }

  .sui-search-box > div {
    width: 100%;
  }
`

export const ResultsOverviewText = styled.h1`
  font-family: var(--ontario-fonts-open-sans);
  font-size: var(--ontario-font-sizes-large);
  font-weight: var(--ontario-font-weights-normal);
  letter-spacing: var(--ontario-font-letter-spacing-xLarge);
  margin-top: var(--ontario-spacing-6);
`

export const MainContainer = styled.main`
  // This min height is calculated by taking 100% of the view height and subtracting the height of the header + footer
  // This ensures the footer is always stuck to the bottom of the page

  min-height: calc(100vh - 430px);
  position: relative;

  @media ${media.small} {
    min-height: calc(100vh - 299px);
  }

  @media ${media.medium} {
    min-height: calc(100vh - 291px);
  }
`

export default {SearchWrapper, ResultsOverviewText, MainContainer}
